export const precertFormReducer =
(
  state: { [key: string]: string | string[] },
  action: { name: string; value: string | string[]; }
) => {
  return {
    ...state,
    [action.name]: action.value,
  }
}
